// src/api/sendEmail.js
import backendClient from "../utils/backendClient";

export const sendEmail = async (email) => {
  const payload = { email };
  const response = await backendClient.post("/subscriber/subscribe-email", payload); // ✅ adjust route
  return response.data;
};
